import React from "react";

// mui components
import { Button } from "@mui/material";

// custom components
import Heading5 from "../../typography/heading-05";

// custom styles
import styles from "./index.module.scss";

const TertiaryButton = ({
	text,
	extraClass,
	extraTextClass,
	startIcon,
	endIcon,
	onClick,
	fullWidth,
	disabled,
	fontType,
    iconOnly, // optional explicit prop to force icon-only square button
}) => {
    // if no text provided but an icon exists, treat as icon-only
    const isIconOnly = iconOnly || (!text && (startIcon || endIcon));
    const customClass = `${styles.tertiaryBtn} ${isIconOnly ? styles.iconOnly : ''} ${extraClass}`;
	const customTextClass = `${styles.tertiaryBtnText} ${extraTextClass}`;

	return (
		<Button
			variant="outlined"
			startIcon={startIcon}
			endIcon={endIcon}
			onClick={onClick}
			className={customClass}
			fullWidth={fullWidth}
			disabled={disabled}
		>
			<Heading5
				text={text}
				fontType={fontType || "semibold"}
				extraClass={customTextClass}
			/>
		</Button>
	);
};

export default TertiaryButton;
